import { useParams } from "react-router-dom";

const useDocumentId = () => {
  const params = useParams();
  const isNew = params.id === "new";
  const documentId = Number(params.id);
  return { documentId: isNew ? null : documentId, isNew };
};

export default useDocumentId;
